// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"273":"0c1c4896","644":"cef3594a","978":"dd8ee5b5"}[chunkId] + ".css";
};